
import { Component, OnInit, ChangeDetectionStrategy, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';


@Component({
  selector: 'no-services',
  templateUrl: './no-services.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ButtonModule, TranslateModule]
})
export class NoServicesComponent implements OnInit {

  readonly onAction = output<{ action: string }>();
  constructor() { }

  ngOnInit(): void {
  }

  addServiceModal() {
    this.onAction.emit({ action: "createService" });
  }
}